import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function ServiceProcessSteps({ content }) {
  const { t } = useLanguage();
  const steps = Array.from({ length: 4 })
    .map((_, i) => ({
      title: content?.[`process_step_${i + 1}_title`],
      desc: content?.[`process_step_${i + 1}_desc`],
    }))
    .filter((s) => s.title);

  if (!steps.length) return null;

  const titlePre = content?.process_title_pre || t("service.process_title_pre");
  const titleAccent = content?.process_title_accent || "";

  return (
    <section data-testid="service-process-section" className="bg-cream py-section sm:py-section-lg border-t border-mist">
      <div className="container-page">
        <Reveal as="div" className="max-w-2xl">
          <span className="eyebrow"><span className="h-1 w-1 rounded-full bg-gold" />{content?.process_eyebrow || t("service.process_eyebrow")}</span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
            {titlePre}{" "}
            {titleAccent ? <span className="gold-foil-text">{titleAccent}</span> : null}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-6 relative">
          <div
            className="hidden lg:block absolute top-[42px] start-[12.5%] end-[12.5%] h-px border-t border-dashed border-gold/40"
            aria-hidden="true"
          />
          {steps.map((s, i) => (
            <Reveal as="div" key={i} delay={i * 0.1}
              className="relative" data-testid={`service-process-step-${i + 1}`}>
              <div className="font-display text-display-2 font-semibold gold-foil-text leading-none">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="mt-5 font-display text-h2 font-semibold text-ink">{s.title}</h3>
              <p className="mt-3 text-sm text-ink/65 leading-relaxed max-w-[28ch]">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
